import React, { useState, useEffect, Fragment } from 'react';
import firstImage from '../images/primero.png';
import secondImage from '../images/segundo.png';
import thirdImage from '../images/tercero.png';
import { Link, useNavigate } from 'react-router-dom';
import TwoButtons from '../components/twoButtons';
import arrow from '../images/arrow-white.png';

const sortByMonth = (users) => {
    users.sort((a, b) => {
        if (b.month !== a.month) {
            return b.month - a.month;
        } else if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else {
            return b.last_batch_points - a.last_batch_points;
        }
    });
};
const sortByTotal = (users) => {
    users.sort((a, b) => {
        if (b.total_points !== a.total_points) {
            return b.total_points - a.total_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.wines - a.wines;
        }
    });
};
const sortByTanda = (users) => {
    users.sort((a, b) => {
        if (b.last_batch_points !== a.last_batch_points) {
            return b.last_batch_points - a.last_batch_points;
        } else if (b.month !== a.month) {
            return b.month - a.month;
        } else {
            return b.total_points - a.total_points;
        }
    });
};
export default function Ranking() {

    const [userData, setUserData] = useState([]);
    const [selectedButton, setSelectedButton] = useState('General');
    const navigate = useNavigate();

    const fetchUserData = () => {
        const xhr = new XMLHttpRequest();
        const url = `${process.env.REACT_APP_API_URL}/users`;
        //const url = `http://wineapi/api/users`;

        xhr.open("GET", url, true);
        xhr.onreadystatechange = function () {
            if (this.readyState === 4) {
                if (this.status === 200) {
                    const users = JSON.parse(this.responseText);

                    // Ordenar los usuarios por puntos en month de mayor a menor inicialmente
                    sortByTotal(users);

                    setUserData(users);
                    console.log("Datos de los usuarios:", users);
                } else {
                    console.error("Error al obtener los datos de los usuarios:", this.status, this.responseText);
                }
            }
        };
        xhr.send();
    };

    useEffect(() => {
        fetchUserData();
    }, []);

    useEffect(() => {
        let sortedUsers = [...userData];
        if (selectedButton === 'General') {
            sortByTotal(sortedUsers);
        } else if (selectedButton === 'Mensual') {
            sortByMonth(sortedUsers);
        } else if (selectedButton === 'Tanda') {
            sortByTanda(sortedUsers);
        }
        setUserData(sortedUsers);
    }, [selectedButton]);

    const redirectToUserPage = (userId) => {
        navigate(`/user/${userId}`);
    };

    const handleButtonClick = (buttonName) => {
        setSelectedButton(buttonName);
    };
    const [hoveredDiv, setHoveredDiv] = useState(null);
    const handleMouseEnter = (divName) => {
        setHoveredDiv(divName);
    };

    const handleMouseLeave = () => {
        setHoveredDiv(null);
    };
    return (
        <div className="winegangs-container">
            <div className="ranking-container">
                <h2>Hall of Fame</h2>
                <div className="row">
                    {userData.length > 1 && (
                        <div className="col-sm-4 ranking-second">
                            <img src={secondImage} alt="Segundo" className="ranking-image" />
                            <div>{userData[1].username} {selectedButton === 'General' ? userData[1].total_points : userData[1].month} <br />{userData[1].relevant_winegang.name ? '(' + userData[1].relevant_winegang.name + ')': ''}</div>
                        </div>
                    )}
                    {userData.length > 0 && (
                        <div className="col-sm-4 ranking-first">
                            <img src={firstImage} alt="Primero" className="ranking-image" />
                            <div>{userData[0].username} {selectedButton === 'General' ? userData[0].total_points : userData[0].month} <br />{userData[0].relevant_winegang.name ? '(' + userData[0].relevant_winegang.name + ')' : ''}</div>
                        </div>
                    )}
                    {userData.length > 2 && (
                        <div className="col-sm-4 ranking-third">
                            <img src={thirdImage} alt="Tercero" className="ranking-image" />
                            <div>{userData[2].username} {selectedButton === 'General' ? userData[2].total_points : userData[2].month} <br />{userData[2].relevant_winegang.name ? '(' + userData[2].relevant_winegang.name + ')' : ''}</div>
                        </div>
                    )}
                </div>
                <div className="main-table ranking-table">
                    {hoveredDiv === 'General' && <div className="hovered-info">Total de puntos</div>}
                    {hoveredDiv === 'Mensual' && <div className="hovered-info">Puntos del último mes</div>}
                    {hoveredDiv === 'Tanda' && <div className="hovered-info">Puntos de la última tanda</div>}
                    <div className="ranking-row title-tab">
                        <div className="title">Pos.</div>
                        <div className="title ">Nombre (Equipo)</div>
                        <div className="title" style={{ cursor: 'pointer' }} onClick={() => handleButtonClick('General')} onMouseEnter={() => handleMouseEnter('General')} onMouseLeave={handleMouseLeave} >{selectedButton === 'General' ? 'Total' : 'Total ▼'}</div>
                        <div className="title" style={{ cursor: 'pointer' }} onClick={() => handleButtonClick('Mensual')} onMouseEnter={() => handleMouseEnter('Mensual')} onMouseLeave={handleMouseLeave} >{selectedButton === 'Mensual' ? 'Mes' : 'Mes ▼'}</div>
                        <div className="title" style={{ cursor: 'pointer' }} onClick={() => handleButtonClick('Tanda')} onMouseEnter={() => handleMouseEnter('Tanda')} onMouseLeave={handleMouseLeave} >{selectedButton === 'Tanda' ? 'Últi.' : 'Últi. ▼'}</div>
                    </div>
                    <div className="ranking-row">
                        {userData.map((user, index) => (
                            <Fragment key={index}>
                                <div className="pos">{index + 1}</div>
                                <button className="item" onClick={() => redirectToUserPage(user.id)}>{user.username} ({user.relevant_winegang.name ? user.relevant_winegang.name : ''})</button>
                                <div className="item">{user.total_points}</div>
                                <div className="item">{user.month}</div>
                                <div className="item">{user.last_batch_points}</div>
                            </Fragment>
                        ))}
                    </div>
                </div>
                {/* }
                <div className="second-buttons">
                    <button className={selectedButton === 'Mensual' ? 'selected-button' : ''} onClick={() => handleButtonClick('Mensual')}>Mensual</button>
                    <button className={selectedButton === 'Mensual' ? 'selected-button' : ''} onClick={() => handleButtonClick('Mensual')}>Mensual</button>
                </div>
                */}
                <div className="ranking-buttons row">
                    <button className="rank-indi"><Link to="/ranking">Individual</Link></button>
                    <button className="rank-wine"><Link to="/ranking-gangs">Winegangs</Link></button>
                </div>
            </div>
            <TwoButtons />
        </div>
    );
}
